import {useTranslation} from "react-i18next";
import {Row} from "react-bootstrap";
import {Icon} from "../components";
import React from "react";

export default function UnderMaintenance(props) {
  const { t } = useTranslation();

  return (
    <>
      <Row style={{marginTop: "150px"}} className="justify-content-md-center">
        <div><Icon icon="maintenance" size="10x" variant="secondary"/></div>
      </Row>
      <Row className="justify-content-md-center">
        <div style={{marginTop: '50px', fontSize: '25px'}}>{t('under_maintenance')}</div>
      </Row>
    </>
  )
}